// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container-_IyY_2 .error-link-Pq2VWp .error-link-underline-EVkAXO{color:var(--semi-color-danger);max-width:200px;margin-left:2px;font-size:14px;text-decoration:underline}.error-container-_IyY_2 .error-link-Pq2VWp .error-link-underline-EVkAXO a{color:var(--semi-color-danger)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error-container": `error-container-_IyY_2`,
	"errorContainer": `error-container-_IyY_2`,
	"error-link": `error-link-Pq2VWp`,
	"errorLink": `error-link-Pq2VWp`,
	"error-link-underline": `error-link-underline-EVkAXO`,
	"errorLinkUnderline": `error-link-underline-EVkAXO`
};
export default ___CSS_LOADER_EXPORT___;
